/******************************************************************************
 *** BgtSpcImplExpndList ** 특별회계기금 수입/지출 결재완료 조회 * 지출결의서 리스트
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DialogTitleBar from "../../common/DialogTitleBar";
import BgtSpcExpndViewDialog from "./dialog/BgtSpcExpndViewDialog";
import Button from "@/js/common/ui/Button";
import { exportToXlsx } from "@/js/common/ExcelExport";

interface Props {
    ognzCd    : string;  // 조직코드(지부)
    acntgYear : string;  // 회계연도
    systemCode: string;  // 시스템코드
    keyword         : string;  // 검색어(문서번호)
    searchKywd: string;  // 검색어(적요)
    dataSbmsnCmptnYn: string;
    expndRsdocSeCd: string;
    sttDt           : string;  // 검색 시작일(수입일자 기준)
    endDt           : string;  // 검색 종료일(수입일자 기준)
    setEndDt        : Function;// set 검색 종료일(초기화 프롭스)
    acntgMonth      : string;  // 월별 조회
    bgtSbjct1stCd   : string;  // 관 코드 
    bgtSbjct2stCd   : string;  // 항 코드
    bgtSbjct3stCd   : string;  // 목 코드
}
const BgtSpcImplExpndList = ( {ognzCd, acntgYear, systemCode, keyword, searchKywd, dataSbmsnCmptnYn, 
    expndRsdocSeCd, sttDt, endDt, acntgMonth, bgtSbjct1stCd, bgtSbjct2stCd, bgtSbjct3stCd, setEndDt}: Props ) => {
    const [expenseDataArr, setExpenseDataArr] = React.useState<any[]>([]);  // 지출결의서 목록
    const [sumExpenseAmt , setSumExpenseAmt ] = React.useState<string>(""); // 지출 내역 합계
    const [deptSumAmount , setDeptSumAmount ] = React.useState<string>(""); // 수입 합계
    const [expndSumAmount, setExpndSumAmount] = React.useState<string>(""); // 지출 합계
    const [bankSumAmount , setBankSumAmount ] = React.useState<string>(""); // 통장 잔액



    const [spcExpndModalOpen, setSpcExpndModalOpen] = React.useState<boolean>(false); // 지출결의서 상세정보 모달
    const [spcAcntgExpndDocId, setSpcAcntgExpndDocId] = React.useState<string>("");   // 지출결의서 문서 ID

    const expenseFldInfs: fldInfsProps[] = [
        { type: "date" , fldNm: "implDt"            , width: 100, headAlign: "center", dataAlign: "center", label: "행위년월일" },
        { type: "text" , fldNm: "expndRsdocSeNm"    , width:  60, headAlign: "center", dataAlign: "center", label: "구분"       },
        { type: "text" , fldNm: "bgtSbjct1stNm"     , width: 100, headAlign: "center", dataAlign: "center", label: "관"         },
        { type: "text" , fldNm: "bgtSbjct2stNm"     , width: 100, headAlign: "center", dataAlign: "center", label: "항"         },
        { type: "text" , fldNm: "bgtSbjct3stNm"     , width: 120, headAlign: "center", dataAlign: "center", label: "목"         },
        { type: "text" , fldNm: "abstrCn"           , width: 210, headAlign: "center", dataAlign: "left"  , label: "적요"       },
        { type: "comma", fldNm: "implAmt"           , width: 120, headAlign: "center", dataAlign: "right" , label: "금액"       },
        { type: "text" , fldNm: "atrzSttsNm"        , width:  70, headAlign: "center", dataAlign: "center", label: "진행상태"   },
        { type: "text" , fldNm: "crtDt"             , width: 120, headAlign: "center", dataAlign: "center", label: "작성일시"   },
        { type: "text" , fldNm: "expndRsdocNo"      , width: 130, headAlign: "center", dataAlign: "left"  , label: "문서번호"   },
    ];

    // 특별회계기금 지출결의서 결재상신 목록 조회
    React.useEffect(() => {
        // 행위년월일 조회 조건 확인
        if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt)) {
            if (sttDt > endDt) {
                AppContext.openAlert({ 
                    title: "행위년월일 검색 조건 확인", 
                    msg: "행위년월일의 검색 시작일자가 종료일자보다 느립니다.", 
                    icon: "warning" 
                }); 
                setEndDt("");
                return;
            } 
        }
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/spc/cmptn/select-bgt-spc-cmptn-expnd-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                orgCd         : ognzCd        , // 조직코드
                acntgYear     : acntgYear     , // 회계연도
                spcAcntgSeCd  : systemCode    , // 시스템ID
                dataSbmsnCmptnYn: dataSbmsnCmptnYn,// 자료제출 여부
                expndRsdocSeCd: expndRsdocSeCd,    // 결의서 구분
                sttDt           : sttDt           , // 검색 시작일(수입일자 기준)
                endDt           : endDt           , // 검색 종료일(수입일자 기준)
                acntgMonth      : acntgMonth      , // 월별 검색
                bgtSbjct1stCd   : bgtSbjct1stCd   , // 관 코드
                bgtSbjct2stCd   : bgtSbjct2stCd   , // 항 코드
                bgtSbjct3stCd   : bgtSbjct3stCd   , // 목 코드
            },
            onSuccessFn: (res: any) => {
                // eslint-disable-next-line no-console
                console.log(res.result);
                setExpenseDataArr(res.result.list);
                setSumExpenseAmt(res.result.listSum.sumImplAmt);
                setDeptSumAmount (res.result.deptSum.sumDpstAmt ); // 수입 합계
                setExpndSumAmount(res.result.expndSum.sumImplAmt); // 지출 합계
                setBankSumAmount (res.result.bankSum.sumDpstAmt ); // 통장 합계

                AppContext.hideSpinner();
            },
        });
    }, [ognzCd, acntgYear, systemCode, dataSbmsnCmptnYn, expndRsdocSeCd, sttDt, endDt, acntgMonth, bgtSbjct1stCd, bgtSbjct2stCd, bgtSbjct3stCd, setEndDt]);

    React.useEffect(() => {
        let sum = 0;
        for (const row of Util.filterTwoFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd, "expndRsdocNo", keyword)) {
            sum += Number(row.implAmt) || 0;
        }
        setSumExpenseAmt(Util.comma(String(sum)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expenseDataArr, searchKywd, keyword]);

    // 엑셀 다운로드
    function downloadExcel() {
        if (Util.filterTwoFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd, "expndRsdocNo", keyword).length === 0) {
            AppContext.openAlert({
                title: "데이터 확인",
                msg: "엑셀로 다운로드할 데이터가 없습니다.",
                icon: "warning"
            });
            return;
        }
        // 엑셀 다운
        exportToXlsx({
            fileName: "특별회계기금 관리",
            columns: expenseFldInfs,
            rows: Util.filterTwoFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd, "expndRsdocNo", keyword)
        });
    }

    return (
        <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
            <div className="dpFlx aiC jcSb mb10 h44 w100p">
                <div className="dpFlx" style={{paddingRight: "80px"}}>
                    <span className="fm-b fs16 fc007bff ls1 fw700">지출 결의서</span>
                </div>
                {/* 상단 요약 3개 박스 */}
                <div className="w450 dpFlx bd1 bdcDDDDDD bdrd6 bgcFAFAFA p10 mb10 mt5">
                    <div className="w150 dpFlx flxdCol aiC">
                        <span className="fm-c fs12 fc666666 mb6">수입 합계</span>
                        <span className="fm-c fs16 fc333333">{Util.comma(deptSumAmount)}</span>
                    </div>
                    <div className="w150 dpFlx flxdCol aiC">
                        <span className="fm-c fs12 fc666666 mb6">지출 합계</span>
                        <span className="fm-c fs16 fc007bff">{Util.comma(expndSumAmount)}</span>
                    </div>

                    <div className="w150 dpFlx flxdCol aiC">
                        <span className="fm-c fs12 fc666666 mb6">통장 잔액</span>
                        <span className="fm-c fs16 fcFF0000">{Util.comma(bankSumAmount)}</span>
                    </div>
                </div>
                <div className="dpFlx aiC gap8" style={{marginRight: "10px"}}>
                    <span className="fm-Pretendard-Light fs16 ls1 fc222222 pr3">합계</span>
                    <span className="fm-Pretendard-Medium fs16 ls1 fc007bff ml10">{Util.comma(sumExpenseAmt)}</span>
                    <span className="fm-Pretendard-Light fs13 ls1 fc222222 pl2 pr3 mt3">원</span>
                </div>
                <div className="dpFlx aiC gap8">
                    <Button buttonName="Excel 다운로드"
                        width={130} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styExcelBtn" borderRadius={5}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => downloadExcel()}
                    />
                </div>
            </div>

            {/* 그리드 */}
            <GridTable
                tableInfo={{
                    tableHeadVsb: true,
                    styleType: AdminGridStyle,
                    fldInfs: expenseFldInfs,
                    ordFld: { name: "implDt", direction: "desc" },
                    dataArr: Util.filterTwoFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd, "expndRsdocNo", keyword),
                    maxRowNums: [30, 50, 100],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor: AppContext.boardThemeColor,
                        buttonWidth: 22,
                        buttonHeight: 24,
                        buttonMarginLeft: 1,
                        buttonMarginRight: 1,
                        fontSize: 13,
                        color: "#666666",
                        letterSpacing: -0.8,
                        fontFamily: "Pretendard-Regular",
                        borderRadius: 3,
                    },
                    footerVsb: true,
                    rowClickFunc: (item: any) => {  // row click
                        setSpcAcntgExpndDocId(item.spcAcntgExpndDocId);
                        setSpcExpndModalOpen(true);
                    },
                }}
            />

            {/* 지출결의서 상세정보 모달 */}
            <Modal modalOpen={spcExpndModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="지출결의서 상세내용" />}
                onCloseFunc={() => {
                    setSpcAcntgExpndDocId("");
                    setSpcExpndModalOpen(false);
                }}
            >
                <div className="h800">
                    <BgtSpcExpndViewDialog
                        spcAcntgExpndDocId   = {spcAcntgExpndDocId}     // 지출결의서 문서 ID
                        systemCode           = {systemCode}
                        setSpcExpndModalOpen = {setSpcExpndModalOpen}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default BgtSpcImplExpndList;